import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const statistics = 'Statistics'

export const getDashboardStatistics = (providerId) => {
  return axios.get(`/${statistics}?providerId=${providerId}`)
}
